module.exports = __webpack_public_path__ + "img/842b6d4.svg";